define(function(require, exports, module) {

    var Base = require('c-base');

    var Route = Base.extend({

        initialize: function() {
            this.bindEvent();
        },

        bindEvent: function() {
            var self = this;
            $(window).on('hashchange', function(e) {
                self.changeHandler(e);
            });
        },

        changeHandler: function(e) {
            var self = this;
            var oldURL = e.oldURL;
            var newURL = e.newURL;

            var oldHash = self.parseHash(oldURL);
            var newHash = self.parseHash(newURL);
            var eventname = newHash == null ? 'null' : newHash;

            self.emit('leave', {
                hash: oldHash
            });

            eventname = self.transferEvent(eventname);

            self.emit(eventname);
        },

        transferEvent: function(eventname) {
            var self = this,
                events = self.events,
                isRegister = 0;

            for (var i in events) {
                if (i == eventname) {
                    isRegister = 1;
                }
            }

            if (!isRegister) {
                eventname = 'null';
            }

            return eventname;
        },

        parseHash: function(url) {
            var hashReg = /#(.+)$/i;
            var execResult = hashReg.exec(url);

            return execResult && execResult[1];
        },

        start: function() {
            var cururl = location.href;
            var curhash = this.parseHash(cururl);
            var eventname = curhash == null ? 'null' : curhash;

            eventname = this.transferEvent(eventname);

            this.emit(eventname);
        }

    });

    let route = new Route();

    UpAct.route = route;

    module.exports = route;
});



// WEBPACK FOOTER //
// ./js/lib/route/index.js